import { Component, Input, OnInit, Output, ViewChild } from "@angular/core";
import { SelectItem, TreeNode } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";

import { UserSignatureAttachmentModalComponent } from './user-signature-attachment-modal/user-signature-attachment-modal.component';
import { UserSignatureModalComponent } from '../shared/component/user-signature-modal/user-signature-modal.component';
import { InstituteDepartamentService } from "../shared/service/institute-departament.service";
import { MessageComponent } from "../shared/component/message/message.component";
import { ReturnMessageModel } from "../shared/model/return-message.model";
import { InstituteService } from "../shared/service/institute.service";
import { UserTypeService } from "../shared/service/user-type.service";
import { InstituteModel } from "../shared/model/institute.model";
import { UserTypeModel } from "../shared/model/user-type.model";
import { UserService } from "../shared/service/user.service";
import { UserModel } from "../shared/model/user.model";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.css"],
})
export class UserComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;

  @ViewChild(UserSignatureModalComponent) signatureModal: UserSignatureModalComponent;

  modalDisplay: boolean = false;
  institutesDepartaments: TreeNode[] = [];
  selectedInstitutesDepartaments: TreeNode[] = [];

  lastEvent: any;
  activeLimit: number;
  activeUsers: number;
  totalRecords: number;

  localUserId: number;
  sameUser: boolean = false;

  signatureImage: string;
  tokenSignature: File[];

  userAttachVisible: boolean = false;
  
  // Logged User
  userData: UserModel;

  // Selected and All
  users: UserModel[] = [];
  user: UserModel = new UserModel();

  dropdownUserType: SelectItem[] = [];

  constructor(
    private userService: UserService,
    private userTypeService: UserTypeService,
    private translateService: TranslateService,
    private instituteService: InstituteService,
    private instituteDepartamentService: InstituteDepartamentService
  ) {
    this.userTypeService.getFilteredPaginated(0, 1000).subscribe((userTypes) => {
      userTypes["rows"].forEach((userTypes) => {
        this.dropdownUserType.push({ label: userTypes.name, value: userTypes });
      });
    }, (r) => this.errorHandler(r && r.error || r));

    this.instituteService.getPaginated({ init: 0, end: 1000 }).subscribe((result) => {
      result.rows.forEach((item: InstituteModel) => {
        let institute = {
          label: item.name,
          data: item.id,
        };

        this.selectedInstitutesDepartaments.push(institute);
      });
    }, (r) => this.errorHandler(r && r.error || r));
  }

  ngOnInit() {
    this.getLoggedUser();

    this.localUserId = parseFloat(localStorage.getItem("user_id"));
  }

  lazy(e) {
    let name = e.filters["name"] ? e.filters["name"].value : null;
    let email = e.filters["email.address"]
      ? e.filters["email.address"].value
      : null;
    let user_type = e.filters["user_type.name"]
      ? e.filters["user_type.name"].value
      : null;
    this.lastEvent = e;

    this.userService
      .getPaginated(e.first, e.rows, name, email, user_type)
      .subscribe(({ count, rows, error, activeCount, activeLimit }) => {
        this.users = !error && rows.length && rows.map((user) => {
          if (!user.email) user.email = {};
          if (!user.email.address) {
            user.email.address = '';
            user.email.id = 0;
          }
          return user as UserModel;
        }) || [];

        this.activeUsers = activeCount;
        this.activeLimit = activeLimit;
        this.totalRecords = count || 0;
      });
  }

  selectAllDepartments() {
    this.selectedInstitutesDepartaments = [];

    if (this.institutesDepartaments && this.institutesDepartaments.length) {
      this.institutesDepartaments.forEach(({ children }) => {
        if (children && children.length) {
          children.forEach((department) => {
            this.selectedInstitutesDepartaments.push(department);
          });
        }
      });
    }
  }

  onSelect(e) {
    this.institutesDepartaments = [];
    this.instituteDepartamentService.findAllInstitutes().subscribe(
      (institutes) => {
        institutes.forEach((item: InstituteModel) => {
          let institute = {
            label: item.name + " (" + item.city + ")",
            data: item.id,
            expanded: true,
            children: [],
          };

          if (item.departaments && item.departaments.length > 0) {
            item.departaments.forEach((children) => {
              institute.children.push({
                label: children.name,
                data: children.id,
              });
            });
          }
          this.institutesDepartaments.push(institute);
        });

        return true;
      },
      (err) => {
        return this.message.error();
      }
    );

    this.selectedInstitutesDepartaments = [];
    this.user = e.data as UserModel;
    this.user.password = null;
    this.sameUser = this.localUserId === this.user.id ? true : false;
  }

  onSave() {
    this.userService.save(this.user).subscribe((r: ReturnMessageModel) => {
      if (r.error) {
        return this.message.error(this.translate(r.message));
      }
      this.message.success(this.translate(r.message));
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onFileSelected(event: UserModel) {
    // this,selectedUser = event
    // const file = event.target.files[0];
    // const timestamp = Date.now();
    // const fileName = timestamp + '_' + file.name;
    // const renamedFile = new File([file], fileName, { type: file.type });
    // this.signatureImage = renamedFile;
  }

  onDelete() {
    if (!this.canDelete()) return this.message.error("invalid_access_rule");

    this.userService.delete(this.user.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(this.translate(r.message));
      else this.message.success(this.translate(r.message));
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onOpenSignatureModal(user) {
    if (user && user.id) {
      this.signatureModal.onShow(user);
    } else console.error('Invalid User Id');
    // this.signatureModal.display = true;
  };

  onRestore() {
    if (!this.canDelete()) return this.message.error("invalid_access_rule");

    this.userService.restore(this.user.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(this.translate(r.message));
      else this.message.success(this.translate(r.message));
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onNew() {
    this.user = new UserModel();
  }

  canDelete() {
    const target_user_type = this.user && this.user.user_type;
		const logged_user_type = this.userData && this.userData.user_type;

    if (!logged_user_type || !target_user_type || !target_user_type.access_rule) {
      return false;
    } else if (target_user_type.access_rule <= logged_user_type.access_rule) {
			return false;
		} else {
      return true;
    }
  }

  showDeleted = () => this.userData && this.userData.isAdmin();

  onUserTypeChange(e) {
    if (e.value) {
      const userType = e.value as UserTypeModel;
      this.user.user_type_id = userType.id;
    } else {
      this.user.user_type_id = null;
    }
  }

  validate(): boolean {
    return UserModel.validate(this.user);
  }

  getLoggedUser() {
    this.userService.getCurrentUserData()
    .subscribe((userData: UserModel) => {
      this.userData = new UserModel(userData);
    }, (r) => this.errorHandler(r && r.error || r));
  }

  async onOpenInstitutesDepartamentsModal(id: number) {
    this.selectedInstitutesDepartaments = [];
    await this.userService.getInstitutesDepartamentsByUserId(id).subscribe(
      (institutes) => {
        institutes.forEach(({ institute_id, departaments }) => {
          this.institutesDepartaments.forEach((item) => {
            if (institute_id == item.data) {
              if (item.children && item.children.length > 0) {
                item.children.forEach((subItem) => {
                  if (departaments.includes(subItem.data)) {
                    this.selectedInstitutesDepartaments.push(subItem);
                  }
                });
              }
              item.partialSelected =
                item.children.length > departaments.length ? true : false;

              if (!item.partialSelected) {
                this.selectedInstitutesDepartaments.push(item);
              }
            }
          });
        });

        return (this.modalDisplay = true);
      },

      (err) => {
        return this.message.error(err);
      }
    );
  }

  onSaveInstitutesDepartaments() {
    let institutes_id = [];
    let record = { user_id: this.user.id, institutes: [] };
    let data = [];

    this.selectedInstitutesDepartaments.forEach((departament) => {
      if (departament.parent) {
        if (!institutes_id.includes(departament.parent.data)) {
          institutes_id.push(departament.parent.data);
        }

        data.push({
          institute_id: departament.parent.data,
          departament_id: departament.data,
        });
      }
    });

    institutes_id.forEach((id) => {
      let departaments = [];

      data.forEach((item) => {
        if (item.institute_id == id) {
          departaments.push(item.departament_id);
        }
      });

      record.institutes.push({ institute_id: id, departaments });
    });

    this.userService.saveInstituteDepartaments(record).subscribe(
      (msg) => {
        this.onNew;
        this.modalDisplay = false;
        return this.message.success();
      },
      (err) => {
        return this.message.error(err);
      }
    );
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
  tUpper = (key) => this.translate(key).toString().toUpperCase();
  tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

  private errorHandler(error) {
    const [errors, params] =  error && error.message.includes(':') ? error.message.split(':') : [error.message, '.'];
    return this.message.error(this.translate(errors) + params);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/user/user.component.ts